type ObjectType<T> = { [key in keyof T]: T[keyof T] };
type RenameKeyMapType<T> = { [key in keyof T]?: string };
type TransformValueMapType<T> = { [key in keyof T]?: (value: any) => any };

const getQueryParamName = <T>(key: keyof T, renameMap: RenameKeyMapType<T> = {}): string => {
  return renameMap[key] ?? (key as string);
};
const getQueryParamValue = <T>(
  key: keyof T,
  object: ObjectType<T>,
  transformMap: TransformValueMapType<T> = {},
): any => {
  const transformCallback: TransformValueMapType<T>[keyof T] = transformMap[key];
  return transformCallback ? transformCallback(object[key]) : object[key];
};

const handleArray = (name, array: any[]) => {
  return array.map((item) => `${name}[]=${item}`);
};
export const objectToQueryParams = <T>(
  object?: ObjectType<T>,
  renameKeyMap: RenameKeyMapType<T> = {},
  transformValueMap: TransformValueMapType<T> = {},
): string => {
  if (!object) return '';
  const queryParams: string[] = [];
  Object.keys(object).forEach((key) => {
    if (object[key] === null || object[key] === undefined || object[key] === '') return;
    const name = getQueryParamName<T>(key as keyof T, renameKeyMap);
    const value = getQueryParamValue<T>(key as keyof T, object, transformValueMap);
    if (Array.isArray(value)) queryParams.push(...handleArray(name, value));
    else queryParams.push(`${name}=${value}`);
  });
  return `${queryParams.join('&')}`;
};
